import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { SEARCH_MODULE_NAMESPACE, SEARCH_REQUEST, SEARCH_AUTOCOMPLETE } from '../../store/search';
import { SearchEntities } from '../../common/enums';

const SearchStore = namespace(SEARCH_MODULE_NAMESPACE)

@Component
class EntitiesSearchSelector extends Vue {


  dtOptions: any[];

  @Prop({ default: () => [], type: [Array], required: false })
  keys: SearchEntities[]


  @Prop({ default: () => [], type: [Array], required: false })
  options: any[]


  @Prop({ default: () => [], type: [Array], required: false })
  value: any;

  @Prop({ default: null, required: false })
  rules: any[]

  /**
   *
   */
  constructor() {
    super();
    this.dtOptions = [];
  }
  get vModel(): any[] {
    return this.value;
  }
  set vModel(value: any[]) {
    this.$emit('input', value)
  }

  @SearchStore.Action(SEARCH_REQUEST)
  storeGetIndependentContractors: () => void;

  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetDeclarants: (payload: { entity?: SearchEntities | SearchEntities[], query: string }) => Promise<any>;


  mounted() {
    this.storeGetIndependentContractors();
    this.dtOptions = JSON.parse(JSON.stringify(this.options || []))
  }

  async onFilter(query: string) {

    let categories: SearchEntities[] = [SearchEntities.Participant]

    return await this.storeGetDeclarants({
      entity: categories,
      query
    })
  }
}

export default EntitiesSearchSelector;


// WEBPACK FOOTER //
// ./src/components/entities-search-selector/index.ts